/**
 * @param {playback-web-player.PlayerFacade.errors$} playerErrors$
 * @param  {ErrorsHandler.handleError} handleError
 */

const subscribeToPlayerErrors = (
    playerErrors$,
    handleError,
) =>
    playerErrors$.subscribe(handleError);

export default subscribeToPlayerErrors;
